import { gql } from '@apollo/client';

// GraphQL query to fetch scopes
export const GET_SCOPES_QUERY = gql`
  query getScopesQuery($input: GetScopesRequest!) {
    getScopes(input: $input) {
      metadata {
        status
        errors
        tracking_id
      }
      result {
        id
        scope
        description
      }
    }
  }
`;
